import { confidenceMeta } from "@/lib/fieldDependencyConstants";

/** High / Medium / Low confidence pill; `ambiguous` adds an explicit marker. */
export default function ConfidenceBadge({ confidence, ambiguous = false, testid }) {
  const m = confidenceMeta(confidence);
  return (
    <span
      className="inline-flex items-center gap-1 ml-mono text-[10px] uppercase tracking-widest px-1.5 py-0.5 border whitespace-nowrap"
      style={{ background: m.bg, color: m.fg, borderColor: m.border }}
      title={m.hint}
      data-testid={testid || `confidence-badge-${confidence}`}
      data-confidence={confidence}
      data-ambiguous={ambiguous}
    >
      {m.label}{ambiguous ? " · ambiguous" : ""}
    </span>
  );
}
